// Test the last character of the filename, return the lot number and lot extension if its a letter
const getLotExtension = fileName => {
  //  We need to test the last character to see if it is a lotExtension
  const lastCharacter = fileName.slice(-1);
  const isNumber = /^\d+$/.test(lastCharacter);

  let lotNumber = fileName;
  let lotExt = '';
  // The last value is a letter, so it's the lot extension
  if (!isNumber) {
    lotExt = lastCharacter;
    // Set the lot number to the value without the lot extension
    lotNumber = fileName.slice(0, -1);
  }
  return { lotNumber, lotExt };
};

export default getLotExtension;
